import RangeSlider from './RangeSlider';
import { DAY_MS, DATE_PRESETS } from './useDateRangePresets';
import { SESSION_TAB_OPTIONS } from './sessionBrowser';
import styles from '../Upload/UploadPanel.module.css';

export function SessionPrimaryFilters({
  filterText, onFilterText, facets,
  showTrack = true, filterTrack = '', onFilterTrack,
  filterCar, onFilterCar, filterDriver, onFilterDriver,
  autoFocus = false,
}) {
  return (
    <div className={styles.filterRow}>
      <input
        className={styles.filterInput}
        type="search"
        placeholder="Filter by track or driver…"
        value={filterText}
        onChange={event => onFilterText(event.target.value)}
        autoFocus={autoFocus}
      />
      {filterText && (
        <button className={styles.filterClear} onClick={() => onFilterText('')} title="Clear filter">×</button>
      )}
      {showTrack && facets.tracks.length > 1 && (
        <select
          className={`${styles.filterSelect} ${filterTrack ? styles.filterSelectActive : ''}`}
          value={filterTrack}
          onChange={event => onFilterTrack(event.target.value)}
        >
          <option value="">Track</option>
          {facets.tracks.map(track => <option key={track} value={track}>{track}</option>)}
        </select>
      )}
      {facets.cars.length > 1 && (
        <select
          className={`${styles.filterSelect} ${filterCar ? styles.filterSelectActive : ''}`}
          value={filterCar}
          onChange={event => onFilterCar(event.target.value)}
        >
          <option value="">Car</option>
          {facets.cars.map(car => <option key={car} value={car}>{car}</option>)}
        </select>
      )}
      {facets.drivers.length > 1 && (
        <select
          className={`${styles.filterSelect} ${filterDriver ? styles.filterSelectActive : ''}`}
          value={filterDriver}
          onChange={event => onFilterDriver(event.target.value)}
        >
          <option value="">Driver</option>
          {facets.drivers.map(driver => <option key={driver} value={driver}>{driver}</option>)}
        </select>
      )}
    </div>
  );
}

export function SessionAdvancedFilters({
  tempBounds, tempRange, onTempRange, tempUnit,
  conditionAvailability, conditions, onConditions,
  dateBounds, dateRange, onDateRange, dateField, onDateField,
  dateSliderMin, dateSliderMax, activeDatePreset, onDatePreset, formatDate,
}) {
  if (!tempBounds && !dateBounds && !conditionAvailability.wet && !conditionAvailability.dry) return null;

  return (
    <div className={styles.filterRow2}>
      {tempBounds && tempRange && (
        <div className={styles.filterGroup}>
          <div className={styles.filterHead}>
            <span className={styles.filterLabel}>Temperature</span>
            {(tempRange[0] > tempBounds.min || tempRange[1] < tempBounds.max) && (
              <button className={styles.filterReset}
                      onClick={() => onTempRange([tempBounds.min, tempBounds.max])}>Reset</button>
            )}
          </div>
          <RangeSlider min={tempBounds.min} max={tempBounds.max} step={1}
                       value={tempRange} onChange={onTempRange}
                       format={value => `${Math.round(value)}°${tempUnit}`} />
        </div>
      )}
      {(conditionAvailability.wet || conditionAvailability.dry) && (
        <div className={styles.filterGroup}>
          <div className={styles.filterHead}><span className={styles.filterLabel}>Conditions</span></div>
          <div className={styles.seg}>
            {[['all', 'All'], ['dry', 'Dry'], ['wet', 'Wet']].map(([value, label]) => {
              const disabled = (value === 'wet' && !conditionAvailability.wet) ||
                (value === 'dry' && !conditionAvailability.dry);
              return (
                <button key={value} className={conditions === value ? styles.segOn : styles.segBtn}
                        disabled={disabled} onClick={() => onConditions(value)}>{label}</button>
              );
            })}
          </div>
        </div>
      )}
      {dateBounds && dateRange && (
        <div className={`${styles.filterGroup} ${styles.filterGroupGrow}`}>
          <div className={styles.filterHead}>
            <span className={styles.filterLabel}>{dateField === 'uploaded' ? 'Upload Date' : 'Session Date'}</span>
            <div className={styles.timePresets}>
              {[
                ['session', 'Session', 'Filter by when the session was driven (the recording date)'],
                ['uploaded', 'Uploaded', 'Filter by when the file was uploaded to TrackAnalysis'],
              ].map(([value, label, title]) => (
                <button key={value} title={title}
                        className={`${styles.filterReset} ${dateField === value ? styles.presetActive : ''}`}
                        onClick={() => onDateField(value)}>{label}</button>
              ))}
            </div>
            <div className={styles.timePresets}>
              {DATE_PRESETS.map(([value, label]) => (
                <button key={value}
                        className={`${styles.filterReset} ${activeDatePreset === value ? styles.presetActive : ''}`}
                        onClick={() => onDatePreset(value)}>{label}</button>
              ))}
            </div>
          </div>
          <RangeSlider min={dateSliderMin} max={dateSliderMax} step={DAY_MS}
                       value={dateRange} onChange={onDateRange} width="100%"
                       format={formatDate} />
        </div>
      )}
    </div>
  );
}

export function SessionOwnershipTabs({ activeTab, onActiveTab }) {
  return (
    <div className={styles.tabRow}>
      {SESSION_TAB_OPTIONS.map(tab => (
        <button
          key={tab.key}
          className={`${styles.tabBtn} ${activeTab === tab.key ? styles.tabActive : styles.tabInactive}`}
          onClick={() => onActiveTab(tab.key)}
          title={tab.detail}
          aria-label={`${tab.label}: ${tab.detail}`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
